(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmr-financing-options"] && !Shopify.designMode) return;
  try {
    
  const financing = document.querySelector('[data-wmr-financing]');

  if (financing) {
    const result = financing.querySelector('[data-financing-result]');
    const buttons = financing.querySelectorAll('[data-financing-months]');
    const currency = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: 'EUR'
    });

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const months = Number(button.dataset.financingMonths);
        const price = Number(financing.dataset.priceCents) / 100;

        buttons.forEach((term) => {
          const active = term === button;
          term.classList.toggle('is-active', active);
          term.setAttribute('aria-pressed', String(active));
        });

        result.textContent = `${currency.format(price / months)} / Monat`;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmr-gift-card-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    const productForm = event.target.closest('form[action*="/cart/add"]');
    if (!productForm) return;
    const selectedOption = event.target.closest('label, option');
    const valueNode = document.querySelector('[data-wmr-gift-value]');
    if (!valueNode || !selectedOption) return;
    const label = selectedOption.textContent.trim();
    if (label.includes('€')) valueNode.textContent = label;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmr-product-system-2028"] && !Shopify.designMode) return;
  try {
    
  /*
   * WMR Kaufbutton-Hotfix 19.07.2026
   * Keine dauerhafte DOM-Beobachtung: Shopify darf den Kaufbutton während
   * Warenkorb- und Variantenaktualisierungen ohne konkurrierende Schleife ändern.
   */
  document.querySelectorAll('[data-wmr-product-system]').forEach((system) => {
    if (system.dataset.wmrBound === '1') return;
    system.dataset.wmrBound = '1';

    const cta = system.dataset.wmrCta;
    const productRoot = document.querySelector('product-information, .product-information');
    if (!productRoot || !cta) return;

    const updateButtonOnce = () => {
      const button = productRoot.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      const label = button.querySelector('span') || button;
      if (label && label.textContent.trim() !== cta) label.textContent = cta;
    };

    updateButtonOnce();

    productRoot.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement)) return;
      window.setTimeout(updateButtonOnce, 250);
    });

    system.querySelector('[data-wmr-scroll-to-buy]')?.addEventListener('click', () => {
      const form = productRoot.querySelector('form[action*="/cart/add"]');
      form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmr-startklar-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wmr-sk-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target =
        document.querySelector('[data-wmr-buy-consent]') ||
        document.querySelector('.buy-buttons-block') ||
        document.querySelector('.product-form-buttons');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
